'use strict';

// XSR export column names (SOK Price Export Spec)
const XSR_COLUMNS = [
  'SALES_ORG',
  'DISTR_CHAN',
  'PRICE_LIST',
  'ARTICLE_ID',
  'UOM_ID',
  'START_DATE',
  'END_DATE',
  'COND_TYPE',
  'PLANNED_RETAIL_PRICE',
  'CURRENCY',
  'DELETION',
  'BASE_UNIT_QUANTITY',
  'BASE_UNIT',
];

module.exports.XSR_COLUMNS = XSR_COLUMNS;
